import { compose, hoistStatics, lifecycle, withState } from 'recompose';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';

import Post from './Post';
import WithLoading from '../../../../components/WithLoading';
import KbPostService from '../../../../services/kbPost.service';

const loadPost = props => async (id) => {
  const { setActivePost, setIsLoading, history } = props;
  setIsLoading(true);
  const resp = await KbPostService.get(id);
  const error = typeof resp !== 'object' || resp.errors;
  if (!error) {
    setActivePost(resp);
    setIsLoading(false);
  } else {
    setIsLoading(false);
    history.push('/kb');
  }
};

const enhance = compose(
  translate('portal'),
  withState('activePost', 'setActivePost', null),
  withState('isLoading', 'setIsLoading', false),
  lifecycle({
    async componentDidMount() {
      await loadPost(this.props)(this.props.match.params.id);
    },
    async shouldComponentUpdate(nextProps) {
      if (nextProps.match.params.id !== this.props.match.params.id) {
        await loadPost(nextProps)(nextProps.match.params.id);
      }
    },
  }),
);

export default withRouter(hoistStatics(enhance)(WithLoading(Post)));



// WEBPACK FOOTER //
// ./src/views/modules/kb/post/index.js